import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { Base } from "ui/Scripts/source/framework/base";
import { SignalRConnectionManager } from "ui/Scripts/source/models/signalR/signalRConnectionManager";
import { IInstantMessageChannelItem, InstantMessageChannelItem } from "ui/Scripts/source/models/instantMessage/instantMessageChannelItem";
import { SubPageHeader } from "../app/header";
import * as instantMessageChannelService from "../../models/services/instantMessageChannelService";
import { customHistory } from "../../framework/customHistory";
import { Session } from "../../models/session/session";
import { ActivePageType, NavigationBar } from "../app/navigation";
import { IUserState } from "../../models/store/storeTypes";
import { AppUtils } from "../../framework/appUtils";
import { InstantMessageChannelListLine } from "./instantMessageChannelListLine";
import { IInstantMessageListItem } from "ui/Scripts/source/models/instantMessage/instantMessageListItem";
import { ConfirmationDialogResult } from "ui/Scripts/source/models/enums";
import { InstantMessageChannelNewDialog } from "./instantMessageChannelNewDialog";

//InstantMessageChannelListMenu
interface IInstantMessageChannelListMenuProp {
    item: IInstantMessageChannelItem;
    onOpen: () => void;
    onRemove: () => void;
    onCancel: () => void;
}

class InstantMessageChannelListMenu extends React.Component<IInstantMessageChannelListMenuProp, {}> {
    handleEditClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onOpen();
    };

    handleRemoveClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onRemove();
    };

    handleCancelClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onCancel();
    };
        
    render() {
        const item = this.props.item;
        if (!item) return null;
        return (
            <div className="listPopupMenu" onClick={this.handleCancelClick}>
                <div className="menu">
                    <div className="line" onClick={this.handleEditClick}>{Translations.Open}</div>
                    <div className={"line" + (item.userIsAdmin ? "" : " disabled")} onClick={this.handleRemoveClick}>{Translations.Remove}</div>
                    <div className="line" onClick={this.handleCancelClick}>{Translations.Cancel}</div>
                </div>
            </div>
        );
    }
}

//InstantMessageChannelList
export interface IInstantMessageChannelListOwnProps {
}

export interface IInstantMessageChannelListStateProps {
    user: IUserState;
    isLoading: boolean;
    items: IInstantMessageChannelItem[];
    lastOpenedInstantMessageChannelId: string;
}

export interface IInstantMessageChannelListDispatchProps {
    loadInstantMessageChannels: () => void;
    //removeInstantMessageChannel: (id: string) => void;
    resetInstantMessageChannels: () => void;
    setLastOpenedInstantMessageChannelId: (id: string) => void;
    setReturnUrl: (url: string) => void;
    onLogout: () => void;
}

type InstantMessageChannelListProp = IInstantMessageChannelListOwnProps & IInstantMessageChannelListStateProps & IInstantMessageChannelListDispatchProps;

interface IInstantMessageChannelListState {
    channels: IInstantMessageChannelItem[];
    selectedId: string;
    showListMenu: boolean;
    showNewDialog: boolean;
    listMenuItem: IInstantMessageChannelItem;
    companyName: string;
}

export class InstantMessageChannelList extends React.Component<InstantMessageChannelListProp, IInstantMessageChannelListState> {
    private hasBeenInitialized: boolean;
    private containerDiv: HTMLDivElement;
    private signalRConnectionManager: SignalRConnectionManager;

    constructor(props: InstantMessageChannelListProp) {
        super(props);
        this.hasBeenInitialized = false;
        this.state = {
            channels: props.items.slice(0),
            selectedId: null,
            showListMenu: false,
            showNewDialog: false,
            listMenuItem: null,
            companyName: ""
        };
    }

    handleLineLongPress = (id: string) => {
        const listMenuItem = this.state.channels.find(i => i.id === id);
        if (Base.isNullOrUndefined(listMenuItem)) return;
        this.setState({
            selectedId: id,
            showListMenu: true,
            listMenuItem
        });
    };

    // #region SignalR
    static getChannelsAfterInstantMessageUpdated = (userCode: string, currentChannels: IInstantMessageChannelItem[], item: IInstantMessageListItem): IInstantMessageChannelItem[] => {
        if (!item) return null;
        const channels = currentChannels.slice(0);
        const channel = channels.find(i => i.id === item.channelId);
        if (!channel) return null;
        const currentLatestDate = channel.latestMessage?.modifyUser?.date;
        if (!Base.isNullOrUndefined(currentLatestDate) && currentLatestDate > item.modifyUser.date) return null;
        channel.latestMessage = item;
        const modifyUserCode = item?.modifyUser?.code ?? userCode;
        if (modifyUserCode !== userCode && !channel.hasUnreadMessages && !item.isUserRead()) {
            channel.hasUnreadMessages = true;
        }
        InstantMessageChannelItem.sortInstantMessageListItems(channels);
        return channels;
    };

    static getChannelsAfterInstantMessageChannelRemoved = (currentChannels: IInstantMessageChannelItem[], id: string): IInstantMessageChannelItem[] => {
        if (!id) return null;
        return currentChannels.filter(i => i.id !== id);
    };

    static getChannelsAfterInstInstantMessageChannelUpdated = (currentChannels: IInstantMessageChannelItem[], item: IInstantMessageChannelItem): IInstantMessageChannelItem[] => {
        if (!item) return null;
        const channels = currentChannels.filter(i => i.id !== item.id);
        channels.push(item);
        InstantMessageChannelItem.sortInstantMessageListItems(channels);
        return channels;
    };

    handleInstantMessageUpdated = (item: IInstantMessageListItem) => {
        const channels = InstantMessageChannelList.getChannelsAfterInstantMessageUpdated(this.props.user.userCode, this.state.channels, item);
        if (!channels) return;
        this.setState({
            channels
        });
    };

    handleInstantMessageChannelRemoved = (id: string) => {
        const channels = InstantMessageChannelList.getChannelsAfterInstantMessageChannelRemoved(this.state.channels, id);
        if (!channels) return;
        this.setState({
            channels
        });
    };

    handleInstantMessageChannelUpdated = (item: IInstantMessageChannelItem) => {
        const channels = InstantMessageChannelList.getChannelsAfterInstInstantMessageChannelUpdated(this.state.channels, item);
        if (!channels) return;
        this.setState({
            channels
        });
    };
    // #endregion SignalR

    componentDidMount(): void {
        const props = this.props;
        const state = this.state;
        props.loadInstantMessageChannels();
        //Scroll last opened item to view
        if (state.channels.length > 0 && !Base.isNullOrEmpty(props.lastOpenedInstantMessageChannelId)) {
            if (this.containerDiv.scrollTo !== null && this.containerDiv.scrollTo !== undefined) {
                const index = state.channels.findIndex(i => i.id === props.lastOpenedInstantMessageChannelId);
                if (index > -1) {
                    const elements = this.containerDiv.getElementsByClassName("loimc");
                    if (elements.length > 0 && !Base.isNullOrUndefined(elements[0])) {
                        const y = (elements[0] as HTMLDivElement).offsetTop;
                        this.containerDiv.scrollTo({
                            top: y,
                            left: 0,
                            behavior: "auto"
                        });
                    }
                }
            }
            props.setLastOpenedInstantMessageChannelId("");
        }
        //Set companyName
        Session.getCompanyName().then((companyName) => {
            this.setState({
                companyName
            });
        });
        this.hasBeenInitialized = true;
        //SignalR
        this.signalRConnectionManager = new SignalRConnectionManager();
        this.signalRConnectionManager.openConnection(appConfig.rootUrl, {
            onUpdateInstantMessageListLine: this.handleInstantMessageUpdated,
            onRemoveInstantMessageChannel: this.handleInstantMessageChannelRemoved,
            onUpdateInstantMessageChannel: this.handleInstantMessageChannelUpdated
        }, Session.getSignalRToken());
    }

    componentWillUnmount(): void {
        this.props.resetInstantMessageChannels();
        this.signalRConnectionManager.closeConnection();
    }

    componentDidUpdate(prevProps: InstantMessageChannelListProp, prevState: IInstantMessageChannelListState) {
        const props = this.props;
        const prevChannelsHash = InstantMessageChannelItem.getHash(prevProps.items);
        const channelsHash = InstantMessageChannelItem.getHash(props.items);
        if (channelsHash === prevChannelsHash) return;
        this.setState({
            channels: props.items.slice(0)
        });
    }

    removeInstantMessageChannel = async () => {
        const state = this.state;
        if (!state.selectedId) return;
        const item = state.channels.find(i => i.id === state.selectedId);
        if (!item) return;
        const result = await AppUtils.showConfirmationDialog(String.format(Translations.DoYouReallyWantToRemoveInstantMessageChannelParameter, item.code));
        if (result !== ConfirmationDialogResult.Yes) return;
        await AppUtils.callService(() => instantMessageChannelService.removeInstantMessageChannel(item.id));
    };

    handleInvitation = async (instantMessageChannelUserId: string, instantMessageChanneld: string, approve: boolean) => {
        const result = await AppUtils.callService(() => instantMessageChannelService.instantMessageChannelUserInvitationHandle(instantMessageChannelUserId, instantMessageChanneld, approve), false);
        if (!result) return;
        this.props.loadInstantMessageChannels();
    };

    setReturnUrl = () => {
        this.props.setReturnUrl("/instantmessage");
    };

    handleLineClick = (id: string) => {
        this.props.setLastOpenedInstantMessageChannelId(id);
        this.setReturnUrl();
        customHistory.push("/instantmessage/" + id);
    };

    handleAddClick = () => {
        this.props.setLastOpenedInstantMessageChannelId("");
        this.setReturnUrl();
        this.setState({
            showNewDialog: true
        });
    };

    handleCloseNewDialog = () => {
        this.setState({
            showNewDialog: false
        });
    };

    handleMenuEdit = () => {
        this.props.setLastOpenedInstantMessageChannelId(this.state.selectedId);
        this.setReturnUrl();
        customHistory.push("/instantmessage/" + this.state.selectedId);
        this.setState({
            showListMenu: false
        });
    };

    handleMenuRemove = () => {
        this.setState({
            showListMenu: false
        });
        this.removeInstantMessageChannel();
    };

    handleMenuCancel = () => {
        this.setState({
            showListMenu: false
        });
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <div>
                <div className="pageContentContainer">
                    <div className="instantMessageChannelListContainer mainListContainer" ref={(elem) => { this.containerDiv = elem; }}>
                        <div className="lineContainer mainLineContainer instantMessageChannelList">
                            {this.hasBeenInitialized && !props.isLoading && state.channels.length < 1 &&
                                <div className="infoContainer">
                                    <div className="alert alert-info" role="alert" dangerouslySetInnerHTML={ { __html: Translations.NoInstantMessageChannelsToShow } } />
                                </div>
                            }
                            {state.channels.map((channel, index) => (
                                <InstantMessageChannelListLine
                                    key={channel.id}
                                    channel={channel}
                                    userCode={props.user?.userCode ?? ""}
                                    selected={this.state.selectedId === channel.id}
                                    first={index === 0}
                                    isLastOpenedInstantMessageChannel={channel.id === props.lastOpenedInstantMessageChannelId}
                                    onClick={this.handleLineClick}
                                    onLongPress={this.handleLineLongPress}
                                    onRefreshList={props.loadInstantMessageChannels}
                                    onHandleInvitation={this.handleInvitation}
                                />
                            ))}
                        </div>
                    </div>
                </div>
                {state.showListMenu &&
                    <InstantMessageChannelListMenu
                        item={this.state.listMenuItem}
                        onOpen={this.handleMenuEdit}
                        onRemove={this.handleMenuRemove}
                        onCancel={this.handleMenuCancel}
                    />
                }
                {state.showNewDialog &&
                    <InstantMessageChannelNewDialog
                        user={props.user}
                        onClose={this.handleCloseNewDialog}
                    />
                }
                <NavigationBar
                    activePage={ActivePageType.InstantMessage}
                    user={props.user}
                />
                <SubPageHeader
                    user={props.user}
                    title={Translations.Channels}
                    onAdd={this.handleAddClick}
                />
            </div>
        );
    }
}